
<template>

  <body>
   <div id="header">
    <div class="header-inner">
      <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>
      <a id="zysq-introduce" href="http://mp.weixin.qq.com/s?__biz=MzAxNzA5Mjc5Ng==&mid=201323575&idx=1&sn=619210f13033538428fa23ae023508e8&scene=1#rd" target="_blank">展业神器简介</a>
    </div>
  </div>
  <div class="clearfix"></div><!--ie7兼容-->
  <!--内容-->
  <div id="content" style="margin-top: 130px;">
    <div id="about-content" class="clearfix">
      <div id="about-info">
        <p>这年头，京东卖保险，天猫双十一保险狂卖10个亿，余额宝二期也是保险！也许你还不知道马云、马化腾、马明哲成立的"三马保险公司"已正式开业！神马回事？皆因保险是金融产品，人类现代生活中衣食住行的刚需，数字化产品无需仓储和物流，天然适合电子商务，行业规模高达1.7万亿之巨。2013年的互联网保险正处于风口浪尖，所以我们邀请有激情有胆识的伙伴一起冲浪，成就属于我们的新时代！ </p>
        <dl>
          <dt>我们在干嘛</dt>
          <dd>我们是一家移动互联网公司，经营保险的电子商务。目前获得数百万人民币的起步资金。我们致力打造一个让广大网民实现"花最少钱买最大保障"的"投保神器"。</dd>
          <dt>我们的团队</dt>
          <dd>折腾创业的都是奇葩的生物，我们是奇葩中的奇葩，我们大多有二次创业经验。我们的创始人是一个外表文艺内心豪迈的萌大叔，还有挂着娃娃脸却操着一手好厨艺的开发总监，恶搞气氛的爱心管家婆。当然，公司里还有很多很多有趣的人，敦厚靠谱UI设计大哥，保持24小时待机的产品哥哥，文艺清新范助理小妹子…！  <br/><span>总之，在一起，就是好玩！</span></dd>
          <dt>我们的待遇</dt>
          <dd>虽然我们只是一家初创公司，但我们同样有社会责任，注重员工的成长与培养，提供市场接轨的薪酬待遇，五险一金及带薪年假，甚至是期权，这都是必需的！</dd>
          <dd>最后，借用马云的一句话：“我不承诺你们一定能发财、升官，我只能说－你们将在这个公司里遭受很多磨难、委屈，但在经历这一切以后，你就会知道什么是成长，以及怎样才可以打造伟大、坚强、勇敢的公司。”</dd>
        </dl>
        <div></div>
      </div>
      <div id="about-erweima">
        <ul>
          <li class="erweima-li-1">
            <span class="erweima-icon"><img src="../../static/images/xlwb-ewm.png" width="100%" alt="官方微博" title="小白保险微博"/></span>
            <span class="wb-title">官方微博</span>
          </li>
          <li class="erweima-li-2">
            <span class="erweima-icon"><img src="../../static/images/wx-erweima.jpg" width="100%" alt="官方微信" title="小白保险微信"/></span>
            <span class="wx-title">官方微信</span>
          </li>
          <li class="erweima-li-3">
            <span class="erweima-icon"><img src="../../static/images/downloaderweima.png" width="100%" alt="app下载" title="小白保险app"/></span>
            <span class="app-title">小白保险APP</span>
          </li>
          <li class="erweima-li-4">
            <span class="erweima-icon"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </body>
</template>
<script>
    export default {
        name: "about",
        data() {
            return{
            }

        },
        methods: {
        },
        mounted() {

        }
    }
</script>

<style scoped>
  @import "../../static/css/rcMain/about.css";
  @import "../../static/css/rcMain/common.css";

</style>



// WEBPACK FOOTER //
// src/components/about.vue